import {
  ADD_BROKER_RESOURCE_ERROR,
  ADD_BROKER_RESOURCE_SUCCESS,
  DELETE_BROKER_RESOURCE_ERROR,
  DELETE_BROKER_RESOURCE_SUCCESS,
  GET_BROKER_RESOURCE,
  GET_BROKER_RESOURCE_FAIL,
  GET_BROKER_RESOURCE_SUCCESS,
  UPDATE_BROKER_RESOURCE_FAIL,
  UPDATE_BROKER_RESOURCE_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  resources: []
}

const Resource = (state = initialState, action) => {
  switch (action.type) {
    case GET_BROKER_RESOURCE:
      return {
        ...state,
        loading: true,
      }
    case ADD_BROKER_RESOURCE_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case ADD_BROKER_RESOURCE_ERROR:
    case UPDATE_BROKER_RESOURCE_FAIL:
    case DELETE_BROKER_RESOURCE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case UPDATE_BROKER_RESOURCE_SUCCESS:
    case DELETE_BROKER_RESOURCE_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case GET_BROKER_RESOURCE_SUCCESS:
      return {
        ...state,
        resources: action.payload,
        loading: false,
      }

    case GET_BROKER_RESOURCE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    default:
      state = { ...state }
      break
  }
  return state
}

export default Resource
